import {uuid} from './validate'
import {getCurrentCompanyUUID} from './company'

export const INVOICE_IMAGES_FOLDER = 'InvoiceImages';
export const COMPANY_LOGO_FOLDER = 'CompanyLogo';
export const EXPENSE_IMAGES_FOLDER = 'ExpenseImages';

function getUploadCompanyUUID() {
    const companyUUID = getCurrentCompanyUUID();
    if (companyUUID == null || companyUUID === '') {
        throw new Error('companyUUID is required for file upload');
    }
    return companyUUID;
}

function getInnerUUID(file) {
    const innerUUID = file.innerUUID;
    if (innerUUID == null || innerUUID === '') {
        throw new Error('innerUUID is required for file upload');
    }
    return innerUUID;
}

export function getUploadRemoteKey(folderName, innerUUID) {
    return getUploadCompanyUUID() + "/" + folderName + "/" + innerUUID + ".jpg";
}

export function prepareFileUpload(uploadData, uploadFileMap, file, folderName) {
    const innerUUID = uuid(null, 37);
    uploadData.companyUUID = getUploadCompanyUUID();
    uploadData.folderName = folderName;
    uploadData.innerUUID = innerUUID;
    uploadFileMap[file.uid] = {
        innerUUID: innerUUID
    };
}

export function takeUploadInnerUUID(uploadFileMap, file) {
    const uploadFile = uploadFileMap[file.uid];
    if (uploadFile == null) {
        throw new Error('upload file innerUUID is required');
    }
    const innerUUID = getInnerUUID(uploadFile);
    delete uploadFileMap[file.uid];
    return innerUUID;
}

export function getDownloadV2Url(requestURL, remoteKey) {
    const separator = requestURL.endsWith("/") ? "" : "/";
    return requestURL + separator + "file/downloadV2?fileName=" + encodeURIComponent(remoteKey);
}
